<div class="content">
    <div class="title"
         data-automation-e2e-selector="title">
        US Treasuries
    </div>
    <div class="none"
         *ngIf="(treasuries | async).length === 0">
        No data available
    </div>
    <div id="itemListWrapperId"
         class="itemListWrapper noSelect"
         *ngIf="(treasuries | async).length > 0">
        <ul id="itemListId"
            class="itemList"
            data-automation-e2e-selector="itemsList">
            <li *ngFor="let item of treasuries | async; let id = index">
                <muni-gameday-radio-item
                    data-automation-e2e-selector="radioItem"
                    *ngIf="live | async"
                    [id]="'ust-' + id"
                    [shortcut]="'ust'"
                    [selected]="item.securityId == (selected | async)?.securityId"
                    (click)="usTreasurySelected(item)"
                    [attr.data-automation-item-state]="item.securityId == (selected | async)?.securityId ? 'checked' : 'unchecked'">
                    <muni-gameday-treasury-ticker
                        [treasury]="item"
                        [highlightName]="true">
                    </muni-gameday-treasury-ticker>
                </muni-gameday-radio-item>
                <muni-gameday-treasury-ticker
                     data-automation-e2e-selector="radioItem"
                    *ngIf="!(live | async)"
                    [treasury]="item"
                    [highlightName]="true">
                </muni-gameday-treasury-ticker>
            </li>
        </ul>
    </div>
</div>